import { combineReducers } from "redux";
import bets from "../features/admin/funtarget/bets/slice";
import result from "../features/admin/funtarget/result/slice";
import winner from "../features/admin/funtarget/winner/slice";
import fun_target_control from "../features/admin/fun_target_control/Slice";

const funTarget = combineReducers({
  bets: bets,
  result: result,
  winner: winner,
  fun_target_control: fun_target_control,
});

export default funTarget;
